import { render, staticRenderFns } from "./BlogSidebar.vue?vue&type=template&id=283d68e2&scoped=true&"
import script from "./BlogSidebar.vue?vue&type=script&lang=js&"
export * from "./BlogSidebar.vue?vue&type=script&lang=js&"
import style0 from "./BlogSidebar.vue?vue&type=style&index=0&id=283d68e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283d68e2",
  null
  
)

export default component.exports